"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const createTopNGroupPointerMethod = (groupByField, topNIndex, methodSuffix) => {
    return ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
        if (concentrationReceivables.length === 0) {
            return {
                kickouts: {},
                calculations: {
                    concentrationLimit: valueConfig.limit,
                    concentrationAmount: totalConcentrationExposure,
                    concentration: 0,
                },
            };
        }
        (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit ryseCoromandel1.${methodSuffix}`);
        const concentrationLimit = valueConfig.limit;
        concentrationReceivables.forEach((rec) => {
            (0, common_1.finleyAssert)(rec.baseFields[groupByField] !== undefined, `baseFields.${groupByField} must be defined to run ryseCoromandel1.${methodSuffix}. Found [${rec.baseFields[groupByField]}]`);
        });
        const grouped = _.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupByField]);
        const groupExposures = Object.entries(grouped).map(([groupKey, receivables]) => ({
            groupKey,
            receivables,
            totalExposure: _.sumBy(receivables, (receivable) => receivable.requiredIntermediateFields.exposure),
        }));
        const sortedGroups = _.orderBy(groupExposures, 'totalExposure', 'desc');
        if (sortedGroups.length < topNIndex) {
            return {
                kickouts: {},
                calculations: {
                    concentrationLimit,
                    concentrationAmount: 0,
                    concentration: 0,
                },
            };
        }
        const targetGroup = sortedGroups[topNIndex - 1];
        const targetReceivables = targetGroup.receivables;
        const targetGroupExposure = targetGroup.totalExposure;
        const totalEligibleExposure = _.sumBy(concentrationReceivables, (receivable) => receivable.requiredIntermediateFields.exposure);
        const concentrationPercentage = common_1.utils.divideByOrZero(targetGroupExposure, totalEligibleExposure);
        const excessPercentage = Math.max(concentrationPercentage - concentrationLimit, 0);
        const kickouts = {};
        if (excessPercentage > 0) {
            for (const receivable of targetReceivables) {
                const { finleyReceivableId, requiredIntermediateFields } = receivable;
                const proRatePercent = common_1.utils.divideByOrZero(requiredIntermediateFields.exposure, targetGroupExposure);
                const kickoutAmount = proRatePercent * excessPercentage * targetGroupExposure;
                kickouts[finleyReceivableId] = kickoutAmount;
            }
        }
        return {
            kickouts,
            calculations: {
                concentrationLimit,
                concentrationAmount: targetGroupExposure,
                concentration: concentrationPercentage,
            },
        };
    };
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'ryseCoromandel1.propertyManagersTop1',
        requiredFields: [
            'baseFields.property_manager_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('property_manager_id', 1, 'propertyManagersTop1'),
    },
    {
        method: 'ryseCoromandel1.propertyManagersTop2',
        requiredFields: [
            'baseFields.property_manager_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('property_manager_id', 2, 'propertyManagersTop2'),
    },
    {
        method: 'ryseCoromandel1.propertyManagersTop3',
        requiredFields: [
            'baseFields.property_manager_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('property_manager_id', 3, 'propertyManagersTop3'),
    },
    {
        method: 'ryseCoromandel1.propertyManagersTop4',
        requiredFields: [
            'baseFields.property_manager_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('property_manager_id', 4, 'propertyManagersTop4'),
    },
    {
        method: 'ryseCoromandel1.ownersTop1',
        requiredFields: [
            'baseFields.owner_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('owner_id', 1, 'ownersTop1'),
    },
    {
        method: 'ryseCoromandel1.ownersTop2',
        requiredFields: [
            'baseFields.owner_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('owner_id', 2, 'ownersTop2'),
    },
    {
        method: 'ryseCoromandel1.ownersTop3',
        requiredFields: [
            'baseFields.owner_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('owner_id', 3, 'ownersTop3'),
    },
    {
        method: 'ryseCoromandel1.ownersTop4',
        requiredFields: [
            'baseFields.owner_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('owner_id', 4, 'ownersTop4'),
    },
    {
        method: 'ryseCoromandel1.ownersTop5',
        requiredFields: [
            'baseFields.owner_id',
            'requiredIntermediateFields.exposure',
        ],
        pointerImplementation: createTopNGroupPointerMethod('owner_id', 5, 'ownersTop5'),
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map